import { isWorkspaceLink } from '@/lib/workspace-links';
import { parseWorkspaceRoute } from './navigation';
import { safeSourceUrl } from './safe-url';
import type { CanvasTarget } from './types';

/**
 * Where a link in a chat answer opens in the canvas beside the chat
 * (CANVAS-NAVIGATION rule 2), or null when it is not a source: another chat,
 * a view or a malformed link keep ordinary link behavior. A link to a retired
 * company fact (`#/workspace/knowledge?fact=…`) names no canvas, so it opens
 * Knowledge like any view link.
 */
export function sourceCanvasTarget(
  href?: string,
  label?: string,
  base?: string,
): CanvasTarget | null {
  if (!href) return null;
  const current = base ?? (typeof window !== 'undefined' ? window.location.href : undefined);
  if (isWorkspaceLink(href, current)) {
    const canvas = parseWorkspaceRoute(new URL(href, current).hash).canvas;
    return canvas && canvas.kind !== 'voice-preview' ? canvas : null;
  }
  const url = safeSourceUrl(href);
  const title = label?.trim();
  return url ? { kind: 'web', id: url, ...(title ? { title } : {}) } : null;
}
